"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_select_1 = require("react-select");
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
var isFirstGroup = function (text, options) { return text === options[0].label; };
exports.GroupHeading = function (props) {
    var isFirst = isFirstGroup(props.children, props.selectProps.options);
    return (React.createElement(exports.GroupHeading.Element, null,
        !isFirst && React.createElement(Divider, null),
        React.createElement(react_select_1.components.GroupHeading, __assign({}, props))));
};
var Divider = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 1px;\n  width: 100%;\n  background-color: #e8e8e8;\n  margin-top: ", ";\n  margin-bottom: ", ";\n"], ["\n  height: 1px;\n  width: 100%;\n  background-color: #e8e8e8;\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), tokens_1.spacing.xsmall, tokens_1.spacing.xsmall);
exports.GroupHeading.Element = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n"], ["\n  font-size: 13px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n"])), tokens_1.fonts.weight.medium);
exports.GroupHeading.theme = function (provided) { return (__assign({}, provided, { paddingLeft: tokens_1.spacing.small, paddingRight: tokens_1.spacing.small, paddingTop: tokens_1.spacing.xsmall, paddingBottom: tokens_1.spacing.xxsmall })); };
var templateObject_1, templateObject_2;
//# sourceMappingURL=group-heading.js.map